/**
 * Created by katarinababic on 24.1.25.
 */
import styled from '@emotion/styled';

export const VideoPlayerContainer = styled.div<{ backgroundImageUrl?: string }>`
  position: relative;
  display: flex;
  flex-direction: column;
  align-items: flex-end;
  background: ${({ backgroundImageUrl }) => (backgroundImageUrl ? `url('${backgroundImageUrl}')` : '#1a1a2e')};
  background-size: cover !important;
  background-position: center center !important;
  background-repeat: no-repeat !important;
  width: 100%;
  aspect-ratio: 16/9;
  border-radius: 16px;
  overflow: hidden;
  border: 1px solid rgba(0, 0, 0, 0.1);
  box-shadow: 0 4px 24px rgba(0, 0, 0, 0.12);
`;

